import { useAppSelector } from 'features/app/hooks';
import { SoundName } from 'features/audio-player/enums';
import { isVriModeSelector } from 'features/multi-mode/store';
import { notifyAboutIncomingCall } from 'features/rns/helpers';

export const useIncomingCall = () => {
  const isVriMode = useAppSelector(isVriModeSelector);

  const getIncomingCallRingtone = (isDeafToHearing = true): SoundName => {
    if (isVriMode) {
      return SoundName.RINGING;
    }

    if (isDeafToHearing) {
      return SoundName.DEAF_TO_HEARING_RINGING;
    }

    return SoundName.HEARING_TO_DEAF_RINGING;
  };

  const playIncomingCallSound = (isDeafToHearing = true) => {
    const ringtone = getIncomingCallRingtone(isDeafToHearing);

    notifyAboutIncomingCall(ringtone);
  };

  return { getIncomingCallRingtone, playIncomingCallSound };
};
